module.exports = __webpack_public_path__ + "static/media/Stellar Max King Headboard - 180 cm_Black.d1e06e01.png";